export default {
  computed: {
    userType() {
      return this.$store.state.user.currentUser.type
    },

    isEditPage() {
      return this.$route.name === 'template-edit'
    },

    isUserTask() {
      const userType = this.userType === 'EMPLOYEE' ? 'diy' : 'client'
      return this.item.type === userType
    },

    isEditable() {
      return this.isEditPage
    },

    isDetailPage() {
      return this.$route.name === 'template-details'
    },

    isTemplatePage() {
      return this.$route.name.includes('template')
    },

    checklistLanguage() {
      return this.$store.state.checklists.language
    },
  },
}
